import type { RevenuePeriod } from "./revenueSummaryService";
import type { LifecycleLabels } from "../../../../utils/lifecycleUtils";
import { ENTITY_ICONS } from "../entityIcons";

export const palette = {
  axis: "#6F6F6F",
  grid: "#E8E8E8",
  axisLine: "#E5E5E5",
  dealCurrent: "#9662FF",
  dealPrevious: "#F76474",
  actual: "#3B44F6",
  prior: "#FF3B30",
};

export type PeriodLabel = "Week" | "Month" | "Year";

export const periodOptions: PeriodLabel[] = ["Week", "Month", "Year"];

export const periodKeys: Record<PeriodLabel, RevenuePeriod> = {
  Week: "by_week",
  Month: "by_month",
  Year: "by_year",
};

export const productGradients = [
  { from: "#8026E3", to: "#C391F9" },
  { from: "#DC3645", to: "#FE6869" },
  { from: "#FF9900", to: "#FFC007" },
  { from: "#0FC9F0", to: "#59C0FE" },
  { from: "#1ABE17", to: "#7EDB7C" },
  { from: "#2F80ED", to: "#86B6F5" },
];

export const teamColors = ["#8B7CF6", "#FF7B7B", "#FFA201", "#2F80ED", "#1ABE17", "#06AED4"];

export interface OverviewMeta {
  icon: string;
  currencyIcon?: boolean;
  avatarClass: string;
  label?: (names: LifecycleLabels) => string;
  countLabel?: (names: LifecycleLabels) => string;
}

export const overviewMeta: Record<string, OverviewMeta> = {
  total_revenue: {
    icon: "ti ti-currency-dollar",
    currencyIcon: true,
    avatarClass: "bg-primary-gradient-100",
  },
  lead_growth: {
    icon: ENTITY_ICONS.lead,
    avatarClass: "bg-secondary",
    label: (names) => `${names.lead} Growth`,
    countLabel: (names) => names.leads,
  },
  pipeline_growth: {
    icon: ENTITY_ICONS.pipeline,
    avatarClass: "bg-info",
    label: (names) => `${names.pipeline} Growth`,
    countLabel: (names) => names.pipelines,
  },
};

export const defaultOverviewMeta: OverviewMeta = {
  icon: "ti ti-chart-bar",
  avatarClass: "bg-info",
};

export const comparisonMeta: Record<
  string,
  { label: string | ((names: LifecycleLabels) => string); unit?: string; className: string; lowerIsBetter?: boolean }
> = {
  closed_deals: {
    label: (names) => `${names.deals} Closed`,
    className: "deals-closed bg-purple-subtle",
  },
  average_sales_cycle: {
    label: "Avg Sales Cycle",
    unit: "days",
    className: "sales-cycle bg-warning-subtle",
    lowerIsBetter: true,
  },
};
